'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'login_expired_manager',
    modelClass: require('./model'),
    viewClass: require('./view'),

    methods: {
        showLoginError: function(data) {
            if (this._isAccountBlocked(data)) {
                this.launchAccountBlockedFlow();
            } else {
                this._showError(this.model.errors[data.messageError]);
            }
        },

        renderCaptcha: function() {
            this.renderCaptcha();
        },
    },
});
